import React from 'react';

const S = 24;
const H = S * 0.6;
const R = 2;
const style = { borderRadius: R, display: 'inline-block', verticalAlign: 'middle' };

// Germany
export function FlagDE() {
  return (
    <svg width={S} height={H} viewBox="0 0 5 3" style={style}>
      <rect width="5" height="1" y="0" fill="#000" />
      <rect width="5" height="1" y="1" fill="#D00" />
      <rect width="5" height="1" y="2" fill="#FFCE00" />
    </svg>
  );
}

// United Kingdom
export function FlagEN() {
  return (
    <svg width={S} height={H} viewBox="0 0 60 30" style={style}>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

// France
export function FlagFR() {
  return (
    <svg width={S} height={H} viewBox="0 0 3 2" style={style}>
      <rect width="1" height="2" x="0" fill="#002395" />
      <rect width="1" height="2" x="1" fill="#fff" />
      <rect width="1" height="2" x="2" fill="#ED2939" />
    </svg>
  );
}

// Italy
export function FlagIT() {
  return (
    <svg width={S} height={H} viewBox="0 0 3 2" style={style}>
      <rect width="1" height="2" x="0" fill="#009246" />
      <rect width="1" height="2" x="1" fill="#fff" />
      <rect width="1" height="2" x="2" fill="#CE2B37" />
    </svg>
  );
}

// Netherlands
export function FlagNL() {
  return (
    <svg width={S} height={H} viewBox="0 0 9 6" style={style}>
      <rect width="9" height="2" y="0" fill="#AE1C28" />
      <rect width="9" height="2" y="2" fill="#fff" />
      <rect width="9" height="2" y="4" fill="#21468B" />
    </svg>
  );
}

// Poland
export function FlagPL() {
  return (
    <svg width={S} height={H} viewBox="0 0 8 5" style={style}>
      <rect width="8" height="2.5" y="0" fill="#fff" />
      <rect width="8" height="2.5" y="2.5" fill="#DC143C" />
    </svg>
  );
}

// Russia
export function FlagRU() {
  return (
    <svg width={S} height={H} viewBox="0 0 9 6" style={style}>
      <rect width="9" height="2" y="0" fill="#fff" />
      <rect width="9" height="2" y="2" fill="#0039A6" />
      <rect width="9" height="2" y="4" fill="#D52B1E" />
    </svg>
  );
}

// Turkey
export function FlagTR() {
  return (
    <svg width={S} height={H} viewBox="0 0 30 20" style={style}>
      <rect width="30" height="20" fill="#E30A17" />
      <circle cx="11" cy="10" r="6" fill="#fff" />
      <circle cx="12.5" cy="10" r="5" fill="#E30A17" />
      <polygon points="16,10 13.5,7.5 14.5,10 13.5,12.5" fill="#fff" />
    </svg>
  );
}

const flagComponents = {
  de: FlagDE,
  en: FlagEN,
  fr: FlagFR,
  it: FlagIT,
  nl: FlagNL,
  pl: FlagPL,
  ru: FlagRU,
  tr: FlagTR,
};

export function getFlag(code) {
  return flagComponents[code] || null;
}
